import { api } from '@/core/api/';
import utils from '@/utils/utilities';

const URL = 'api/billing/contract';

export const getBillingDetailInitFilters = (billId) => {
  return api.get(`${URL}/detailinitfiltersrp/${billId}`);
};

export const getDisicplinesByServiceTypeId = (billId) => {
  return api.get(`${URL}/getdisciplinesrp/${billId}`);
};

export const getBillingDetails = (payload) => {
  return api.get(`${URL}/details`, { params: { ...payload } });
};

export const getSpecialistsByDisciplineTypeId = (billId) => {
  return api.get(`${URL}/getspecialistsrp/${billId}`);
};

export const getVisits = (payload) => api.post(`${URL}/searchvisits`, payload);

export const getVisitDates = (payload) =>
  api.get(
    `${URL}/visits/dates/${payload.contractId}/${payload.academicYearId}/${payload.monthNumber}`
  );

export const getVisitCertificate = (contractId, specialistId, visitSummaryId) =>
  api.get(
    `${URL}/visitcertificate/${contractId}/${specialistId}/${visitSummaryId}`
  );

export const saveVisitCertificate = (payload) =>
  api.post(`${URL}/visitcertificate`, payload, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

export const getContractServiceDocument = (
  contractId,
  serviceTypeId,
  visitSummaryId
) =>
  api.get(
    `${URL}/servicedocument/${contractId}/${serviceTypeId}/${visitSummaryId}`
  );

export const getAllContractServiceDocument = async (payload) =>
  utils.convertToBlob((await api.post(`${URL}/servicedocument`, payload)).data);

export const checkMassiveServiceFlagsAsIntervined = async (payload) =>
  api.post(`${URL}/checkmassiveserviceflags`, payload);

export const checkUncheckServiceFlagAsIntervined = async (payload) =>
  api.post(`${URL}/checkuncheckserviceflag`, payload);

export const getAdjustmentReasons = () => api.get(`${URL}/adjustmentreasons`);

export const saveAdjustment = (payload) =>
  api.post(`${URL}/adjustment`, payload);

export const saveBillAdjustment = (payload) =>
  api.post(`${URL}/billAdjustment`, payload, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

export const deleteAdjustment = (adjustmentId) =>
  api.delete(`${URL}/adjustment/${adjustmentId}`);

export const getAdjustments = (billId, contractId, visitSummaryId) =>
  api.get(`${URL}/adjustment/${billId}/${contractId}/${visitSummaryId}`);

export const getAdjustmentsSeparated = (billId, contractId, visitSummaryId) =>
  api.get(
    `${URL}/adjustment-separated/${billId}/${contractId}/${visitSummaryId}`
  );

export const updateAdjustmentRecommendedStatus = (payload) =>
  api.post(`${URL}/updateadjustmentrecommendedstatus`, payload);

export const updateAdjustmentRecommendedAmount = (payload) =>
  api.post(`${URL}/updateadjustmentrecommendedamount`, payload);

export const IsValidateInvoiceJuly = (academicYearId, companyId) =>
  api.get(`${URL}/IsValidateInvoiceJuly/${academicYearId}/${companyId}`);

export const getExecutionSummary = (billId) =>
  api.get(`${URL}/executionSummary/${billId}`);
